import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import SearchForm from './Form'
import { present } from '../settings/Form/validators'

@inject('searches', 'websites')
@observer
export default class AddSearch extends Component {
  website = this.props.websites.current

  handleData = data => {
    return this.props.searches.create(data).then(search => {
      const { location: { state={} }, router } = this.props
      if (state.return_to) {
        router.replace({
          ...state.return_to,
          query: { ...state.return_to.query, search_id: search.id }
        })
      }
    })
  }
  
  /*
   * Validate for a unique title.
  
   * Based on how our validations are set up, we are returning false for unique
   * titles and true for non-unique titles.
   * 
   * In the future, it would be great if a method like this could be abstracted
   * to live with our other validators.
   */
  uniqueTitle = (title) => {
    const duplicate = this.props.searches.find(s => s.title === title)
    return !!duplicate
  }

  render() {
    const validations = [
      { field: 'title', validate: present, message: 'Please Enter a Search Name' },
      { field: 'title', validate: this.uniqueTitle, message: 'Please Enter a Unique Search Name' }
    ]
    
    return (
      <SearchForm onData={this.handleData} validations={validations} />
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/SearchLibrary/Add.js